import NProgress from 'nprogress';
import router from './index';
import 'nprogress/nprogress.css';
import { validatenull } from "@/common/common.js"
import { getSysConfig } from '@/api/common';
NProgress.configure({ showSpinner: false });
const whiteList = [
  '/home',
  '/help',
  '/company',
  '',
  '/',
  '/news',
  '/newsDetail',
  '/contactUs',
  '/login',
  '/register',
  '/trace',
];

// 受 ltl_switch 控制的 LTL 专属路径（隐藏时禁止直接访问）
const ltlGuardedPaths = [
  '/ltl/orderList',
  '/ltl/orderPlace',
  '/ltl/orderResult',
  '/ltl/orderOrder',
  '/ltl/rateList',
  '/ltl/FBA',
  '/ltl/product',
  '/ltl/address',
  '/ltl/recharge',
  '/ltl/finance',
  '/ltl/invoice',
];

// 实时拉取 ltl_switch
function checkLtlHidden() {
  return new Promise((resolve) => {
    getSysConfig().then((res) => {
      if (res && res.code == 1 && res.data) {
        resolve(Number(res.data.ltl_switch) === 1);
      } else {
        resolve(false);
      }
    }).catch(() => resolve(false));
  });
}

router.beforeEach((to, from, next) => {
  NProgress.start();
  const guardLtl = (cb) => {
    if (ltlGuardedPaths.indexOf(to.path) === -1) {
      cb();
      return;
    }
    checkLtlHidden().then((hidden) => {
      if (hidden) {
        NProgress.done();
        next({ path: '/ltl/index' });
      } else {
        cb();
      }
    });
  };

  if (JSON.parse(window.localStorage.getItem("userInfo1"))) {
    if (to.path === '/login') {
      next({ path: '/' })
      document.title = 'ECPAI OS'
      NProgress.done()
    }else if(to.path == '/ltl/index'){
      if(!validatenull(to.query)){
        let data = JSON.parse(to.query.data)
        window.localStorage.setItem("userInfo1",JSON.stringify(data.data))
        next()
      }else{
        document.title = to.meta.title
        next()
      }
    }else {
      guardLtl(() => {
        document.title = to.meta.title
        next()
      });
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      document.title = to.meta.title
      next()
    } else if(to.path == '/ltl/index'){
      if(!validatenull(to.query)){
        let data = JSON.parse(to.query.data)
        window.localStorage.setItem("userInfo1",JSON.stringify(data.data))
        next()
      }else{
        next({ path: '/login' })
        document.title = '登录'
        NProgress.done()
      }
    }else{
      next({ path: '/login' })
      document.title = '登录'
      NProgress.done()
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
